<template>
  <section v-if="!this.$store.state.page.isMobile" >
<!--    <h2 class="subTitle">스포츠</h2>-->

    <div class="inner" style="margin-top: 20px; padding: 0; width: 1261px;">
      <div class="new_page_tabpc">
        <router-link to="/sport/korean" class="cho"><span>엘스포츠 한국형</span></router-link>
        <router-link to="/sport/korean_new" ><span>벳컨 한국형</span></router-link>
      </div>
      <div class="cate2">
<!--        <div class="sort">-->
<!--          <a @click="movePage('list/korean')" :class="{'active' : type === 'korean'}">한국형 모드</a>-->
<!--          <a @click="movePage('list/european')" :class="{'active' : type === 'european'}">유럽형 모드</a>-->
<!--        </div>-->
<!--        6046,687890,35232,48242,154830,154914,131506,1149121-->
        <div class="box">
          <a class="all" @click="changeCategory(null)">ALL</a>
          <a class="c2"  @click="changeCategory(6046)">FOOTBALL</a>
          <a class="c1"  @click="changeCategory(154914)">BASEBALL</a>
          <a class="c3"  @click="changeCategory(48242)">BASKETBALL</a>
          <a class="c4"  @click="changeCategory(154830)">VOLLEYBALL</a>
          <a class="c5"  @click="changeCategory(35232)">HOCKEY</a>
          <a class="c6"  @click="changeCategory(687890)">E-SPORTS</a>
          <a class="c7"  @click="changeCategory(131506)">AMERICAN FOOTBALL</a>
          <a class="c8"  @click="changeCategory('ETC')">ETC</a>
        </div>
      </div>
    </div>

    <div class="nbox" style="width: 1261px;">
      <div class="contLeft" style="min-height: 1000px; width: 950px;">
        <table class="listTable01" v-if="bonus.length > 0" style="display: block;" >
          <colgroup>
            <col width="132" />
            <col width="288" />
            <col width="138" />
            <col width="288" />
            <col width="74" />
          </colgroup>
          <!-- <tr>
            <th colspan="6" >
              <img src="@/assets/img/ico/ico_hart.png" />
              &nbsp;&nbsp;<span>보너스 배당</span>
            </th>
          </tr>
          <tr v-for="(rowB, indexBonus) in bonus" :key="'bonusIndex'+indexBonus">
            <td >보너스배당</td>
            <td class="al" @click="addBonus(rowB)" :class="{'active': checkCart(rowB, '보너스')}">
              <div class="fbox" :class="{'active': checkCart(rowB, '보너스')}">
                <span class="fl">{{ rowB.name }}이상+보너스배당</span>
                <span class="fr up">{{ rowB.rate }}</span>
              </div>
            </td>
            <td>VS</td>
            <td class="ar">
              <div class="fbox">
                <span class="fl">&nbsp;</span>
                <span class="fr">[{{ rowB.name }}↑ + 보너스] 위반시 낙첨처리</span>
              </div>
            </td>
            <td>진행</td>
          </tr> -->
        </table>
        <KoreanFolders v-if="isLoading" :lists="lists" :add-cart="addCart" :check-cart="checkCart"></KoreanFolders>
        <Loading style="text-align: center; margin-top: 20%;" v-else></Loading>
      </div>

      <!--      카트      -->
      <NewCart v-if="user"></NewCart>
      <NewCartNotLogin v-else></NewCartNotLogin>
      <!-- <div class="contRight" :class="{'fixedCart': isScrollDown}" style="position:fixed; left: calc(calc(1190px * 0.77) + calc((100% - 1190px) / 2) + 10px);" v-if="!sticky">
        <NewCart :toggle-stick="toggleStick"></NewCart>
      </div>
      <div class="contRight" style="position:absolute; left: calc(calc(1190px * 0.77) + calc((100% - 1190px) / 2) + 10px);" v-else>
        <NewCart :toggle-stick="toggleStick"></NewCart>
      </div> -->
    </div>
  </section>
  <div v-else>
    <div class="new_page_tab">
      <router-link to="/sport/korean" class="cho"><span>엘스포츠 한국형</span></router-link>
      <router-link to="/sport/korean_new" ><span>벳컨 한국형</span></router-link>
    </div>
    <div class="categorys" style="padding: 0;">
      <button @click="changeCategory(null)" :class="{'active': !this.category}">전체</button>
      <button @click="changeCategory(6046)" :class="{'active': this.category === 6046}"><img src="@/assets/img/ico/1.png"></button>
      <button @click="changeCategory(154914)" :class="{'active': this.category === 154914}"><img src="@/assets/img/ico/1111.png" style="width: 23px; height: 23px;"></button>
      <button @click="changeCategory(48242)" :class="{'active': this.category === 48242}"><img src="@/assets/img/ico/3.png"></button>
      <button @click="changeCategory(154830)" :class="{'active': this.category === 154830}"><img src="@/assets/img/ico/5.png"></button>
      <button @click="changeCategory(35232)" :class="{'active': this.category === 35232}"><img src="@/assets/img/ico/2.png"></button>
      <button @click="changeCategory(687890)" :class="{'active': this.category === 687890}"><img src="@/assets/img/ico/77.png"></button>
      <button @click="changeCategory(131506)" :class="{'active': this.category === 131506}"><img src="@/assets/img/ico/6.png"></button>
    </div>


    <!-- 인디케이터 -->
    <div class="m-game3" v-if="!isLoading" style="min-height: 100px; text-align: center;">
      <Loading></Loading>
    </div>

    <!-- 게임 데이터 -->
    <div class="m-game3" v-if="isLoading && lists.length === 0" style="min-height: 100px; text-align: center;">
      <div class="day" style="margin-top: 40px;">
        <span class="t2" style="text-align: center;">진행중인 경기가 없습니다.</span>
      </div>
    </div>
    <!-- 경기목록   -->
    <MWrapperFolder
        v-else-if="isLoading && lists.length > 0"
        :check-cart="checkCart"
        :add-cart="addCart"
        :lists="lists"
        :bonus="bonus"
        :add-bonus="addBonus"
    ></MWrapperFolder>
    <transition name="fade">
      <MCart v-if="user && this.cartItem.length > 0"></MCart>
    </transition>
  </div>
</template>

<script>
import MCart from '@/components/Betting/MLsportCartNew'
import NewCart from '@/components/Betting/KoreanLsportCartNew'
import NewCartNotLogin from '../../../../components/Betting/LsportKoreanCartNewNotLogin'
import Loading from '@/components/Loading'
import KoreanFolders from '@/components/Game/Sports/Korean/FolderLsport'
import MWrapperFolder from '@/components/Game/Sports/Korean/MWrapperFolderLsport'
import {mapState} from "vuex";
import MSG from "@/contants/msg";

export default {
  name: "Sports",
  components: {
    MCart,
    NewCart,
    // Cart,
    KoreanFolders,
    // MKoreanPrice
    // MPrice,
    MWrapperFolder,
    Loading,
    NewCartNotLogin
  },
  data: function(){
    return {
      type: 'korean',
      category: null,
      isLoading: false,
      search: false,
      sticky: false,
      keyword: null,
      lists : null,
      payload: {},
      isScrollDown: false,
    }
  },
  computed: {
    //보너스
    bonus: function(){
      return this.$store.state.setting.settings?.config.option.bettingOption.sportsFolder.filter(e => e.active === true) || []
    },
    // 마감시간
    endTime: function(){
      return this.$store.state.setting.settings.config.option.gameEndtime.find(e => e.gameName === '스포츠').endTime
    },
    menuVisible(){
      return this.$store.getters['MENU_VISIBLE'];
    },
    koreanLsportVisible(){
      return this.menuVisible?.find(e => e.name === '스포츠-한국형(엘스포츠)')?.visible
    },
    ...mapState({
      originList: state => state.lsport.originList,
      user: state => state.user.user,
      cartItem: state => state.lsport.cart,
    }),
  },
  watch: {
    category: function(val){
      if (!val) return this.lists = this.originList;
      if (val === 'ETC') return this.lists = this.originList.filter(game => [6046,154914, 48242, 154830, 35232, 687890, 131506].indexOf(Number(game.sportId)) < 0 )
      this.lists = this.originList.filter(e=> e.sportId === val);
    },
  },
  mounted: function() {
    if (!this.koreanLsportVisible){
      this.$store.dispatch('SHOW_ERR_MSG3', '한국형(엘스포츠)은 점검중 입니다.')
      this.$router.push({ path: '/main' })
    }
    this.$store.dispatch('ALL_LSPORT_CLEAR_ITEM')
    window.addEventListener('scroll', this.handleScroll)
    this.initFolder();
    setInterval(this.removeGames, 1000)
  },
  beforeDestroy: function() {
    this.$store.dispatch('ALL_LSPORT_CLEAR_ITEM')
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    handleScroll: function () {
      const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
      if (currentScrollPosition > 200) this.isScrollDown = true;
      else this.isScrollDown = false;
    },
    // 폴더 불러오기
    initFolder: function(){
      return this.$store.dispatch('GET_LSPORT_LIST', { payload: { sitename: 'viking' }})
          .then(() => {
            this.isLoading = true;
            this.lists = this.originList;
          }).catch(err => {
            alert(err.response.data.error);
          })
    },
    // 페이지 이동
    movePage: function(page){
      this.$router.push({path: `/${page}`})
    },
    // 게임종목
    changeCategory: function(sport){
      this.category = sport;
    },
    // 베팅카트에 담기
    addCart: function (bets, folders, game) {
      if (this.user){
        const config = this.user.members_detail_setting;
        if (!config.베팅권한.한국형.active) return this.$store.dispatch('SHOW_ERR_MSG', MSG.error.authorization);
      } else return this.$store.dispatch('SHOW_ERR_MSG', MSG.error.isNotLogin);

      const item = {
        gameId: game.id,
        gameSeq: game.seq,
        betsSeq: bets.seq,
        betsStatus: bets.status,
        betsId: bets.id,
        betsName: bets.name,
        betsUpdated: false,
        betsPrevOdds: bets.price,
        sportsId: game.sportId,
        marketsId: folders.marketId,
        foldersSeq: folders.seq,
        foldersType: folders.type,
        foldersStatus: folders.status,
        odds: bets.price,
        line: bets.line || null,
        leagueId: game.leagueId,
        leagueNameKr: game.league.nameKr,
        leagueNameEn: game.league.nameEn,
        leagueNameIcon: game.league.icon,
        sportNameKr: game.sport.nameKr,
        sportNameEn: game.sport.nameEn,
        sportNameIcon: game.sport.icon,
        homeNameKr: game.homeTeam.nameKr,
        homeNameEn: game.homeTeam.nameEn,
        awayNameKr: game.awayTeam.nameKr ,
        awayNameEn: game.awayTeam.nameEn,
        marketNameKr: folders.market.nameKr,
        marketNameEn: folders.market.nameEn,
        startTime: game.startTime,
        odds1: folders.bets.find(e => e.name === '1' || e.name === 'Over' || e.name === 'Yes').price,
        odds2: folders.bets.find(e => e.name === 'X')?.price,
        odds3: folders.bets.find(e => e.name === '2' || e.name === 'Under' || e.name === 'No').price,
        betType: '프리매치(한국형2)',
        detailType: null,
        currentPeriod: game.currentPeriod,
        currentTime: game.currentTime,
        homeScore: game.homeResult,
        awayScore: game.awayResult,
        penalty: null,
        penaltyReason: null,
      };
      console.log('item', item)
      this.$store.dispatch('ADD_LSPORT_CART_ITEM', item);
    },
    addBonus: function (bonus) {
      if (this.user){
        const config = this.user.members_detail_setting;
        if (!config.베팅권한.한국형.active) return this.$store.dispatch('SHOW_ERR_MSG', MSG.error.authorization);
      } else return this.$store.dispatch('SHOW_ERR_MSG', MSG.error.isNotLogin);
      this.$store.dispatch('ADD_LSPORT_CART_ITEM', {
        gameId: null,
        betsSeq: null,
        betsName: '1',
        sportsId: null,
        marketsId: null,
        foldersSeq: null,
        odds: bonus.rate,
        betsUpdated: false,
        betsPrevOdds: bonus.rate,
        line: null,
        leagueNameKr: '보너스',
        leagueNameEn: '보너스',
        leagueNameIcon: null,
        sportNameKr: '보너스',
        sportNameEn: '보너스',
        sportNameIcon: null,
        homeNameKr: bonus.name,
        homeNameEn: bonus.name,
        awayNameKr: '보너스' ,
        awayNameEn: '보너스',
        marketNameKr: '보너스',
        marketNameEn: '보너스',
        startTime: null,
        odds1: bonus.rate,
        odds2: bonus.rate,
        odds3: bonus.rate,
        betType: '보너스',
        detailType: null,
        currentPeriod: 0,
        currentTime: 0,
        homeScore: 0,
        awayScore: 0,
        penalty: null,
        penaltyReason: null,
      })
    },
    // 카트내역 체크해서 표시
    checkCart: function (bets, type = '일반') {
      if (type === '보너스') {
        let index = this.cartItem.find(item => item.odds === bets.rate)
        return !!index;
      } else {
        let index = this.cartItem.find(item => item.betsSeq === bets.seq)
        return !!index;
      }
    },

    // 시간이 지난 항목들 안보이게 설정
    removeGames: function () {
      if (this.lists && this.lists.length > 0) {
        let endEvents = this.lists.filter(e => this.$options.filters.gameStarted(e.startTime, this.endTime))
        endEvents.forEach((ele) => {
          let index = this.lists.indexOf(ele)
          if (index>=0) {
            this.lists.splice(index, 1)
          }
        })
      }
      // 카트 아이템수정
      if (this.$store.state.lsport.cart){
        let endEvents = this.$store.state.lsport.cart.filter(e => this.$options.filters.gameStarted(e.startTime, this.endTime))
        endEvents.forEach((ele) => {
          let index = this.$store.state.lsport.cart.indexOf(ele)
          if (index>=0) {
            this.$store.state.lsport.cart.splice(index, 1)
          }
        })
      }
    },
    toggleStick: function(){
      this.sticky = !this.sticky;
    }
  },
}
</script>

<style scoped>
.event-detail-list-move {
  transition: transform 0.8s;
}
.event-detail-list {
  transition: transform 0.8s;
}
.categorys::-webkit-scrollbar{
  display:none;
}

.fixedCart {
  top: 70px;
}

</style>
